<template>
    <div class="container-fluid">
        <header class="sync-page-heading">
            <div>
                <h1>Member synchronization</h1>
                <p>Review delegates from the registration portal before transferring them into the application database.</p>
            </div>
            <router-link to="/member" class="btn btn-outline-secondary">
                <i class="pi pi-arrow-left" aria-hidden="true"></i>
                <span>Back to directory</span>
            </router-link>
        </header>

        <MemberSyncReview></MemberSyncReview>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import MemberSyncReview from "@/components/master/MemberSyncReview.vue";

export default defineComponent({
    name: "MemberSyncPage",
    components: {
        MemberSyncReview
    }
})
</script>

<style scoped>
.sync-page-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin: 0 0 1.5rem;
}

.sync-page-heading h1 {
    margin: 0;
    color: #1f2937;
    font-size: 1.75rem;
    font-weight: 700;
    letter-spacing: -0.025em;
}

.sync-page-heading p {
    margin: 0.35rem 0 0;
    color: #6b7280;
    font-size: 0.95rem;
}

.sync-page-heading .btn {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    white-space: nowrap;
}

@media (max-width: 575.98px) {
    .sync-page-heading {
        flex-direction: column;
        margin-bottom: 1rem;
    }

    .sync-page-heading h1 {
        font-size: 1.5rem;
    }
}
</style>
